import type { FunctionComponent } from 'react';
import type { CardIconProps } from './CardIcon.interface';

import clsx from 'clsx';
import { BoxIcon } from './CardIcon.styled';

export const CardIcon: FunctionComponent<CardIconProps> = ({ color, size, icon }) => {
  return <BoxIcon className={clsx(color, size)}>{icon}</BoxIcon>;
};
